import { COMPANY } from "./constants";
import { SERVICES } from "../data/services";

export function localBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    "@id": `${COMPANY.siteUrl}/#business`,
    name: COMPANY.name,
    url: COMPANY.siteUrl,
    image: `${COMPANY.siteUrl}/images/hero-main.jpg`,
    logo: `${COMPANY.siteUrl}/logo.svg`,
    description:
      "VCO Group specializes in commercial and industrial masonry, bricklaying, and siding, backed by full project management from planning through delivery.",
    address: {
      "@type": "PostalAddress",
      streetAddress: COMPANY.addressLine1,
      addressLocality: COMPANY.city,
      addressRegion: COMPANY.region,
      postalCode: COMPANY.postalCode,
      addressCountry: COMPANY.country,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: COMPANY.geo.lat,
      longitude: COMPANY.geo.lng,
    },
    areaServed: COMPANY.areaServed,
    email: COMPANY.email,
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "VCO Group Services",
      itemListElement: SERVICES.map((service) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          serviceType: service.serviceType,
          name: service.name,
          description: service.summary,
        },
      })),
    },
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${COMPANY.siteUrl}/#website`,
    name: COMPANY.name,
    url: COMPANY.siteUrl,
    publisher: { "@id": `${COMPANY.siteUrl}/#business` },
  };
}

export function serviceSchema(service) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: service.serviceType,
    name: service.name,
    description: service.summary,
    provider: { "@id": `${COMPANY.siteUrl}/#business` },
    areaServed: COMPANY.areaServed,
    url: `${COMPANY.siteUrl}/services#${service.anchor}`,
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${COMPANY.siteUrl}${item.path}`,
    })),
  };
}
